// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	production: false,
	hmr: false,
	// g2e_api: 'http://localhost:3000/',
	g2e_api: 'https://api.grupo2e.com.br/',
	// g2e_json_server: 'http://localhost:3000/',
	g2e_www: 'http://sistema.grupo2e.com.br/',
	// g2e_www: 'http://localhost:4200/',
	// g2e_www: 'https://sunny-taiyaki-306cd2.netlify.app/',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
